export default "__VITE_ASSET__CLW$MPuL__"